import { useEffect, useState } from 'react';
import { NewsWidget, dashboardWidgetRegistry, STALE_WIDGET_IDS } from '@/core/widgets/export';
import { Layouts } from 'react-grid-layout';
import { MNIDashboard } from '@/core/preferences/export';

function getAllWidgetIdsFromLayouts(layouts: Layouts): string[] {
  const ids: string[] = [];

  for (const breakpoint in layouts) {
    if (layouts[breakpoint]) {
      layouts[breakpoint].forEach(value => {
        if (!STALE_WIDGET_IDS.includes(value.i) && !ids.includes(value.i)) ids.push(value.i);
      });
    }
  }
  return ids;
}

function getActiveWidgets(
  activeWidgets: ActiveWidgetsForDashboard | undefined,
  dashboard: MNIDashboard | undefined,
): ActiveWidgetsForDashboard | undefined {
  if (!dashboard) return undefined;

  const newActiveWidgets = activeWidgets?.activeWidgets || [];
  const widgetsFromLayout = getAllWidgetIdsFromLayouts(dashboard.layouts);

  const activeWidgetIds = newActiveWidgets.map(value => value.id);

  let widgetAdded = false;

  widgetsFromLayout.forEach(value1 => {
    if (!activeWidgetIds.includes(value1)) {
      const widget = dashboardWidgetRegistry.getById(value1);
      if (widget) {
        newActiveWidgets.push(widget);
        widgetAdded = true;
      }
    }
  });

  const filteredWidgets = newActiveWidgets.filter(value => widgetsFromLayout.includes(value.id));
  // eslint-disable-next-line
  const widgetRemoved = filteredWidgets.length != newActiveWidgets.length;

  if (widgetAdded || widgetRemoved || (!activeWidgets && newActiveWidgets)) {
    return {
      dashboardId: dashboard.id,
      activeWidgets: filteredWidgets,
    };
  } else return activeWidgets;
}

export interface ActiveWidgetsForDashboard {
  dashboardId: string;
  activeWidgets: NewsWidget[];
}

export default function useWidgetsFromLayouts(
  dashboard?: MNIDashboard,
): ActiveWidgetsForDashboard | undefined {
  const [activeWidgets, setActiveWidgets] = useState<ActiveWidgetsForDashboard>();

  useEffect(() => {
    if (dashboard?.id !== activeWidgets?.dashboardId) setActiveWidgets(undefined);

    setActiveWidgets(getActiveWidgets(activeWidgets, dashboard));
    // eslint-disable-next-line
  }, [dashboard]);

  return activeWidgets;
}
